<template>
  <div
    style="font-family:Titillium Web;line-height: 1.0;"
    class="p-3 ml-1 mr-1  shadow-lg rounded-lg animate__animated animate__fadeIn"
  >
    <div class="row">
      <div class="col-12 p-2">
        <div class="row">
          <div class="col-sm-3 animate__animated animate__flipInY animate__delay-1s">
            <div class="text-center">
              <img
                src="@/static/photo/fast1.png"
                class="kinoLightBox img-fluid mx-auto"
                style="border-radius: 20p"
              />
            </div>
            <p class="text-center font-bold underline italic" style="font-size:13px;">Fast</p>

            <p
              class="text-center font-bold text-sm"
              style="font-size:13px;"
            >Code yang sudah di optimasi dengan cermat</p>
          </div>
          <div class="col-sm-3 animate__animated animate__flipInY animate__delay-1s">
            <div class="text-center font-bold">
              <img
                src="@/static/photo/lampu1.png"
                class="kinoLightBox img-fluid mx-auto"
                style="border-radius: 20p"
              />
            </div>

            <p class="text-center font-bold underline italic" style="font-size:13px;">Analytics</p>

            <p
              class="text-center font-bold text-sm"
              style="font-size:13px;"
            >Setiap projectnya terhubung secara langsung dengan google analytics</p>
          </div>
          <div class="col-sm-3 animate__animated animate__flipInY animate__delay-1s">
            <div class="text-center font-bold">
              <img
                src="@/static/photo/res1.png"
                class="kinoLightBox img-fluid mx-auto"
                style="border-radius: 20p"
              />
            </div>

            <p class="text-center font-bold underline italic" style="font-size:13px;">Responsive</p>

            <p
              class="text-center font-bold text-sm"
              style="font-size:13px;"
            >Layout ku bisa digunakan di semua device kecil atau besar</p>
          </div>
          <div class="col-sm-3 animate__animated animate__flipInY animate__delay-1s">
            <div class="text-center font-bold">
              <img
                src="@/static/photo/rocket1.png"
                class="kinoLightBox img-fluid mx-auto"
                style="border-radius: 20p"
              />
            </div>
            <p class="text-center font-bold underline italic" style="font-size:13px;">Cross Platform</p>

            <p
              class="text-center font-bold text-sm"
              style="font-size:13px;"
            >Project ku mudah untuk di gunakan di berbagai platform</p>
          </div>
        </div>
        <br />
      </div>
      <div class="col-12">
        <div class="row" v-if="subskill.length>0">

          <div class="col-6" v-for="(item, index) in subskill" :key="index+'subskill'">
            <p
              style="font-size:13px;"
              class="p-2  text-sm font-bold animate__animated animate__flipInX "
            >{{item.title}}</p>
            <div
              style="width: 100%;"
              :style="`background-color:#ddd;`"
              class="rounded-lg shadow-lg animate__animated animate__flipInX "
            >
              <div class="rounded-l-lg text-white  pt-2 pr-2" :style="`width:${item.persen}%;background:${item.warna};`" style="text-align:right;">{{item.persen}}%</div>
            </div>
          </div>

          <div class="col-12 " v-for="(item, index) in skill" :key="index+'skill'">
            <p
              style="font-size:13px;"
              class="p-2  text-sm font-bold animate__animated animate__flipInX "
            >{{item.title}}</p>
            <div
              style="width: 100%;"
              :style="`background-color:#ddd;`"
              class="rounded-lg shadow-lg animate__animated animate__flipInX "
            >
              <div class="rounded-l-lg text-white  pt-2 pr-2" :style="`width:${item.persen}%;background:${item.warna};`" style="text-align:right;">{{item.persen}}%</div>
            </div>
          </div>
        </div>
      </div>
      <br>
      <br>
      <br>
      <br>
<!--  -->
<br>
<div>
<div v-if="activity.length>0">
  <img :src="activity[0].gambar" v-viewer class="kinoLightBox img-fluid " alt="">
</div>

     <p class="p-3 font-times italic underline font-bold">MY STACKS</p>
      </div>
    </div>
    <h1 style="font-size:1px;opacity:0.1;">Portofolio TA_Maliki / Taufik Akbar Maliki PORTOFOLIO WEBSITE OFFICIAL</h1>
  </div>
</template>
<script>
import axios from 'axios'
// let rdb = firebase.database()
import autophp from '@/plugins/autophp'
let sdb = new autophp()
let urlnya='https://gis.officialapp.my.id'
export default {
  data () {
    return {
      skill:[],
      subskill:[],
      activity:[]
    }
  },
  layout: 'portofolio',
  methods: {},
  mounted () {
    sdb.collection("app_portofolio_skill",false,urlnya).doc().select(`select * from app_portofolio_skill`).then(res => {
        this.skill=res;
        this.$forceUpdate();
    });
    
    sdb.collection("app_portofolio_subskill",false,urlnya).doc().select(`select * from app_portofolio_subskill`).then(res => {
        this.subskill=res;
        this.$forceUpdate();
    });
     sdb.collection("app_portofolio_activity",false,urlnya).doc().select(`select * from app_portofolio_activity`).then(res => {
        this.activity=res;
        this.$forceUpdate();
    });
    
  },
}
</script>
<style scoped>
.progress {
  text-align: right;
  font-size: 14px;
  padding-top: 1px;
  padding-bottom: 10px;
  color: white;
  padding-right: 10px;
  padding-bottom: 4px;
}

/* <div class="row">
<div class="co3-6">
    <p class="p-2  text-sm font-bold animate__animated animate__flipInX ">HTML</p>
    <div style="width: 100%;background-color: #ddd;" class="rounded-lg shadow-lg animate__animated animate__flipInX ">
    <div
    class="progress bg-orange-400"
        style="width: 90%; "
    >90%</div>
    </div>
    <!--  -->
    <p class="p-2  font-bold animate__animated animate__flipInX ">CSS</p>
    <div style="width: 100%;background-color: #ddd;" class="rounded-lg shadow-lg animate__animated animate__flipInX ">
    <div
    class="progress bg-blue-400 pt-2"
        style="width: 90%;"
    >90%</div>
    </div>
    <!--  -->
        <p class="p-2  font-bold animate__animated animate__flipInX ">VUE.JS</p>
    <div style="width: 100%;background-color: #ddd;" class="rounded-lg shadow-lg animate__animated animate__flipInX ">
    <div
    class="progress bg-green-400  pt-2"
        style="width: 90%;"
    >90%</div>
    </div>
    <!--  -->
        <p class="p-2  font-bold animate__animated animate__flipInX ">JAVASCRIPT</p>
    <div style="width: 100%;background-color: #ddd;" class="rounded-lg shadow-lg animate__animated animate__flipInX ">
    <div
    class="progress bg-yellow-400"
        style="width: 90%;"
    >90%</div>
    </div>
    <!--  -->
    <p class="p-2  font-bold animate__animated animate__flipInX ">PUPETTER / WEB SCRAPING / AUTOMATION</p>
    <div style="width: 100%;background-color: #ddd;" class="rounded-lg shadow-lg animate__animated animate__flipInX ">
    <div
    class="progress bg-gray-400"
        style="width: 90%;"
    >90%</div>
    </div>
        <p class="p-2  font-bold animate__animated animate__flipInX ">FIREBASE / FIRESTORE / FUNCTION / DLL</p>
    <div style="width: 100%;background-color: #ddd;" class="rounded-lg shadow-lg animate__animated animate__flipInX ">
    <div
    class="progress bg-yellow-600"
        style="width: 90%;"
    >90%</div>
    </div>
    <!--  -->

        <p class="p-2  font-bold animate__animated animate__flipInX ">NODE.JS</p>
    <div style="width: 100%;background-color: #ddd;" class="rounded-lg shadow-lg animate__animated animate__flipInX ">
    <div
    class="progress bg-black"
        style="width: 90%;"
    >90%</div>
    </div>

    <!--  -->
</div>
<div class="col-6">
        <p class="p-2  font-bold animate__animated animate__flipInX ">PHP</p>
    <div style="width: 100%;background-color: #ddd;" class="rounded-lg shadow-lg animate__animated animate__flipInX ">
    <div
    class="progress "
        style="width: 90%;background:#777BB3;"
    >90%</div>
    </div>
        <p class="p-2  font-bold animate__animated animate__flipInX ">Nuxt.js</p>
    <div style="width: 100%;background-color: #ddd;" class="rounded-lg shadow-lg animate__animated animate__flipInX ">
    <div
    class="progress bg-green-700"
        style="width: 90%;"
    >90%</div>
    </div>
        <p class="p-2  font-bold animate__animated animate__flipInX ">Laravel</p>
    <div style="width: 100%;background-color: #ddd;" class="rounded-lg shadow-lg animate__animated animate__flipInX ">
    <div
    class="progress "
        style="width: 90%;background:#FF291A;"
    >90%</div>
    </div>
        <p class="p-2  font-bold animate__animated animate__flipInX ">SQL</p>
    <div style="width: 100%;background-color: #ddd;" class="rounded-lg shadow-lg animate__animated animate__flipInX ">
    <div
    class="progress "
        style="width: 90%;background:#2D7699;"
    >90%</div>
    </div>
        <p class="p-2  font-bold animate__animated animate__flipInX ">MONGODB</p>
    <div style="width: 100%;background-color: #ddd;" class="rounded-lg shadow-lg animate__animated animate__flipInX ">
    <div
    class="progress bg-green-200"
        style="width: 90%;"
    >90%</div>
    </div>
        <p class="p-2  font-bold animate__animated animate__flipInX ">NEDB</p>
    <div style="width: 100%;background-color: #ddd;" class="rounded-lg shadow-lg animate__animated animate__flipInX ">
    <div
    class="progress bg-orange-200"
        style="width: 90%;"
    >90%</div>
    </div>
    <p class="p-2  font-bold animate__animated animate__flipInX ">GIT</p>
    <div style="width: 100%;background-color: #ddd;" class="rounded-lg shadow-lg animate__animated animate__flipInX ">
    <div
    class="progress bg-gray-700"
        style="width: 90%;"
    >90%</div>
    </div>
</div> */
</style>
